import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import * as _ from 'lodash';

import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'assessment-assets-originform',
    templateUrl: './assessment-assets-originform.component.html',
    styleUrls: ['./assessment-assets-originform.component.scss'],
    standalone: false
})
export class AssessmentAssetsOriginFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  constructor(
    protected formConstructor: PrFormConstructor,
    protected subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor, subscriptionFacade);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }
  floored(value) {
    return Math.round(value * 100) / 100;
  }
  get repartition() {
    return this.form.value;
  }
  get totalAllocated() {
    const amount = _.pick(this.form.value, [
      'personally.percent',
      'family.percent',
      'companyOrGroupOrAssociation.percent',
    ]);

    return (
      this.floored(
        _.chain(_.sum(_.values(amount).map(el => +el.percent))).value(),
      ) / 100
    );
  }
  get allocationPanel() {
    if (this.totalAllocated > 1)
      return {
        display: 'danger',
        icon: 'error',
        text: `${Math.round(
          this.totalAllocated * 100,
        )}% au total - Vous ne pouvez pas repartir plus de 100% `,
      };
    else if (this.totalAllocated < 1)
      return {
        display: 'warning',
        icon: 'warning',

        text: `Il vous reste ${Math.round(
          (1 - this.totalAllocated) * 100,
        )}% à répartir
        `,
        // , soit ${
        //   this.form.value.amount * Math.round((1 - this.totalAllocated) * 100)
        // }€
      };
    else if (this.totalAllocated == 1)
      return {
        display: 'success',
        icon: 'check',
        text: "Félicitations, vous avez réparti 100% de l'origine de votre patrimoine",
      };
    // else
    //   return {
    //     display: "danger",
    //     icon: "error",
    //     text: "Vous ne pouvez pas repartir 0% dans un support",
    //   };
  }

  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.selectErrorInputAndScroll(this);
    if (this.form.valid) {
      if (this.totalAllocated == 1) {
        this.subscriptionFacade.submitPledge(this);
      }
    }
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
